import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => {
  const connectorLineStyle = {
    content: '""',
    display: 'block',
    width: 68,
    height: 2,
    backgroundColor: theme.color.greys[30],
    position: 'absolute',
    top: 18,
  };

  return createStyles({
  containerWrapper: {
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',

    '& .MuiStepper-root': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      maxWidth: 960,
      margin: '0 auto',
      paddingTop: 24,
      paddingBottom: 72,
      [theme.breakpoints.down('md')]: {

        justifyContent: 'center',
        paddingBottom: 0,
        paddingTop: 24,
      },
    },

    '& .MuiStepper-horizontal': {
      alignItems: 'flex-start',
      justifyContent: 'center',
    },

    '& .MuiStep-root': {
      position: 'relative',
      marginRight: 136,
      padding: 0,
      '&:first-of-type': {
        '& $iconRoot': {
          '&:before': {
            display: 'none',
          },
        },
      },
      '&:last-of-type': {
        marginRight: 0,
        '& $iconRoot': {
          '&:after': {
            display: 'none',
          },
        },
      },

      [theme.breakpoints.down('md')]: {
        marginRight: 76,
      },
      [theme.breakpoints.down('sm')]: {
        marginRight: 16,
      },
    },

    '& .MuiStepLabel-root': {
      flexDirection: 'column',

      '& .MuiStepLabel-iconContainer': {
        width: 36,
        height: 36,
        paddingRight: 0,
      },

      '& .MuiStepLabel-label': {
        textAlign: 'center',
      },
    },

    '& .MuiStepConnector-root': {
      display: 'none',
    },

    '& .MuiStepIcon-root': {
      width: 36,
      height: 36,
      padding: 6,
      borderRadius: 50,
    },
  },

  stepLabel: {
    position: 'absolute',
    top: 5,
    left: '50%',
    transform: 'translateX(-50%)',
  },

  stepLabelActive: {
    '& $stepLabel': {
      color: theme.color.greys[0],
    },
  },

  stepCompleted: {
    '& $stepLabel': {
      display: 'none',
    },
  },
  stepInactive: {
    opacity: 0.4,
  },
  stepActive: {
    '& $iconRoot': {
      '&:after': {
        opacity: 0.4,
      },
    },
  },

  stepLabelText: {
    margin: 0,
    position: 'absolute',
    maxWidth: 140,
    width: 140,
    left: -50,
    textAlign: 'center',
    marginTop: 16,

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  labelTextMobile: {
    textAlign: 'center',
    paddingBottom: 16,
    marginTop: 16,
  },

  iconRoot: {
    display: 'flex',
    alignItems: 'center',
    '&:before': {
      ...connectorLineStyle,
      left: -68,
      [theme.breakpoints.down('md')]: {
        width: 38,
        left: -38,
      },
      [theme.breakpoints.down('sm')]: {
        width: 8,
        top: '50%',
        left: -8,
      },
    },

    '&:after': {
      ...connectorLineStyle,
      left: 36,
      [theme.breakpoints.down('md')]: {
        width: 38,
      },
      [theme.breakpoints.down('sm')]: {
        width: 8,
        top: '50%',
      },
    },

    '& > svg': {
      width: 36,
      height: 36,
      borderRadius: '100%',
    }
  },

  iconActive: {
    '&:before': {
      backgroundColor: theme.color.greys[40],
    },

    '& $stepIcon': {
      '& circle': {
        fill: theme.color.oranges[50],
        stroke: theme.color.oranges[50],
      },
    },
  },

  iconCompleted: {
    '& $stepIcon': {
      '& circle': {
        fill: theme.color.greens[100],
        stroke: theme.color.greens[100],
      },

      '& path': {
        fill: theme.color.greys[0],
        stroke: theme.color.greys[0],
      },
    },

    '&:before, &:after': {
      backgroundColor: theme.color.greys[40],
    },

  },

  stepIcon: {
    '& circle': {
      fill: theme.color.greys[10],
      stroke: theme.color.greys[40],
    },
  }
});
}, { name: 'HorizontalStepper', index: StylesIndexInjections.UI_MOLECULES });
